import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Constants.
 */

export enum IntegrationIconsEnum {
  GMAIL = 'GMAIL',
  GOOGLE = 'GOOGLE',
  MESSENGER = 'MESSENGER',
  MICROSOFT = 'MICROSOFT',
  OFFICE365 = 'OFFICE365',
  TWILIO = 'TWILIO',
  ZOOM = 'ZOOM',
  HANGOUTS_MEET = 'HANGOUTS_MEET',
  HANGOUTS = 'HANGOUTS',
  SKYPE = 'SKYPE',
  TEAMS = 'TEAMS',
  WEB_TOPIC = 'WEB_TOPIC',
}

/*
 * Props.
 */

interface IntegrationIconProps {
  integrationIcon: IntegrationIconsEnum;
}

/*
 * Style.
 */

interface IconStyleProps {
  $icon?: IntegrationTypeIconsEnum;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  grid-column: 1;
  grid-row: 1;
  width: 20px;
  height: 20px;
  margin-right: -1px;
  background-image: ${(p) => (p.$icon !== undefined ? `url(${integrationTypeIconUrls[p.$icon]})` : 'none')};
`;

/*
 * Component.
 */

export const IntegrationIcon: FC<IntegrationIconProps> = ({integrationIcon}) => {
  const theme = useUserTheme();
  // For some integrations, we explicitly choose to use an icon from our "normal" component.
  if (integrationIcon === IntegrationIconsEnum.WEB_TOPIC) {
    return (
      <StyledIconDiv>
        <Icon name="linkTiny" color={theme.greys.shade70} />
      </StyledIconDiv>
    );
  }

  return <StyledIconDiv $icon={integrationIcon} />;
};

/*
 * Integration type icons.
 */

type IntegrationTypeIconsEnum = Exclude<IntegrationIconsEnum, IntegrationIconsEnum.WEB_TOPIC>;
type IntegrationTypeIconUrls = {[T in IntegrationTypeIconsEnum]: string};
/* eslint-disable global-require */
const integrationTypeIconUrls: IntegrationTypeIconUrls = {
  [IntegrationIconsEnum.GMAIL]: require('../../assets/images/integrations/gmail20.svg'),
  [IntegrationIconsEnum.GOOGLE]: require('../../assets/images/integrations/google20.svg'),
  [IntegrationIconsEnum.MESSENGER]: require('../../assets/images/integrations/messenger20.svg'),
  [IntegrationIconsEnum.MICROSOFT]: require('../../assets/images/integrations/microsoft20.svg'),
  [IntegrationIconsEnum.OFFICE365]: require('../../assets/images/integrations/office36520.svg'),
  [IntegrationIconsEnum.TWILIO]: require('../../assets/images/integrations/twilio20.svg'),
  [IntegrationIconsEnum.ZOOM]: require('../../assets/images/integrations/zoom20.svg'),
  [IntegrationIconsEnum.HANGOUTS_MEET]: require('../../assets/images/integrations/hangoutsMeet20.svg'),
  [IntegrationIconsEnum.HANGOUTS]: require('../../assets/images/integrations/hangouts20.svg'),
  [IntegrationIconsEnum.SKYPE]: require('../../assets/images/integrations/skype20.svg'),
  [IntegrationIconsEnum.TEAMS]: require('../../assets/images/integrations/teams20.svg'),
};
